import React, {forwardRef, useImperativeHandle, useState, useRef, useEffect} from 'react'
import {Modal, DatePicker, Select, message, Input, Button} from 'antd'
import './index_mic.scss';//鉴于iop样式要根据主题色进行变化，其他系统样式固定
import moment from "moment";
import Tools from '../tools/Tools'
import InstructTypeSelect from './InstructTypeSelect'
import BatchCarSelect from "./BatchCarSelect";
import WWInput from "./antdReset/WWInput";
import WWTable from "./Table";
let formatTime = 'YYYY-MM-DD HH:mm:ss'
import ExportFileInstruct from './ExportFileInstruct'
const Option = Select.Option;
let repeatObj = {
    1:365,
    2:52,
    3:12
}
let repeatDescObj = {
    1:Strings.rs14391,
    2:Strings.rs14392,
    3:Strings.rs14393
}
function BatchInstructModalMicDetail(props, ref) {
    const [detailVisible, setDetailVisible] = useState(false)
    const [name, setName] = useState('')
    const [time, setTime] = useState('')
    const [deadlineTime,setDeadlineTime] = useState('');
    const [format, setFormat] = useState('')
    const [routine, setRoutine] = useState("")
    const [id, setId] = useState('')
    const [isAdd, setIsAdd] = useState(true)
    const [sendType,setSendType] = useState("")
    const [emails,setEmails] = useState([""])
    const [instructResponseList,setInstructResponseList] = useState([])
    const [taskDetailId,setTaskDetailId] = useState('');
    useImperativeHandle(ref, () => ({
        showDetailModal: (id,detailId) => {
            setDetailVisible(true)
            if(id) {
                setId(id)
                setIsAdd(false)
                getDetail(id);
                getInstructResponse(id,detailId)
                detailId && setTaskDetailId(detailId)
            } else {
                setIsAdd(true)
            }
        }
    }))
    //指令详情
    function getDetail(id) {
        let url = `${Tools.getApiUrl("taskDetail",props.platform)}${id}`
        Tools.fetch(url,'GET',function (data) {
            if (data.code === 0){
                let instructObj = data.data || {}
                setName(instructObj.name)
                let routine_temp = instructObj.hasOwnProperty("routine")?instructObj.routine.toString():""
                setRoutine(routine_temp)
                setFormat(instructObj.format)
                setTime(instructObj.time?moment(instructObj.time*1000):'')
                let imeis = []
                instructObj.deviceSimpleBeans.map(function (item) {
                    imeis.push(item.imei)
                })
                let sendType_temp = instructObj.hasOwnProperty("sendType")?instructObj.sendType.toString():""
                setSendType(sendType_temp);
                setDeadlineTime(instructObj.deadlineTime?moment(instructObj.deadlineTime*1000):'')
                setEmails(instructObj.emails?instructObj.emails:[""])
            } else {
                message.error(data.message)
            }
        })
    }
    //查询指令任务详情-车辆响应情况-list
    function getInstructResponse(id,detailId){
        let url = `${Tools.getApiUrl("exeHistory",props.platform)}?taskId=${id}`
        if(!Tools.isNull(detailId)){
            url += `&taskDetailId=${detailId}`;
        }
        Tools.fetch(url,'GET',function (data) {
            if (data.code === 0){
                setInstructResponseList(data.data);
            } else {
                message.error(data.message)
            }
        })
    }
    function formExeParams(){
        let params = {
            taskId:id,
        }
        if(!Tools.isNull(taskDetailId)){
            params.taskDetailId=taskDetailId
        }
        return params;
    }
    //隐藏弹框
    function hideModal() {
        setName('')
        setRoutine('')
        setFormat('')
        setTime('')
        setSendType('')
        setDeadlineTime('')
        setEmails([""])
        setDetailVisible(false)
    }

    //获取emails展示组件
    const emailItems = ()=>{
        return emails.map((item,index) =>{
            return <div className="modal_item ">
                <span className="form_span">{Strings.mailsInstruct}{index+1}</span>
                <div className={"form_value"}>
                    <WWInput className="w200" value={item} disabled={!isAdd}></WWInput>
                </div>
            </div>
        })
    }

    //
    const columns_instruct_response=[
        {
            title: Strings.carCode,
            dataIndex: 'carCode',
            width: '20%'
        }, {
            title: Strings.imei,
            dataIndex: 'imei',
            width: '30%'
        },
        {
            title: Strings.lastexetime,
            dataIndex: 'lastExecTime',
            width: '30%',
            render:(text,record)=>{
                return Tools.formatTimeYMDHms(text)
            }
        },
        {
            title: Strings.exeresult,
            dataIndex: 'execInfo',
            width: '20%'
        },
    ]

    return <Modal transitionName="" maskTransitionName=""
                  className="default_modal wid1000 mic_model"
                  width=""
                  destroyOnClose={true}
                  visible={detailVisible}
                  onCancel={()=>hideModal()}
                  maskClosable={false}
                  title={Strings.instructDetailTitle}
                  footer={null}>
                    <div className="batch_instruct_content">
                        <div className={"device_content"} style={{flex:1.5}}>
                            <div className={"commonTitle"}><label>{Strings.instruct_response_list}</label></div>
                            <div className="border_table">
                                <div className={"bathOptsWrapper"}>
                                    <div className={"leftopts"}>&nbsp;</div>
                                    <ExportFileInstruct params={formExeParams()} type={"commandTaskHistory"} closeModal={()=>hideModal()}></ExportFileInstruct>
                                </div>
                                <WWTable  className="new_app_table"
                                          pagination={false}
                                          columns={columns_instruct_response}
                                          innerHeight={300}
                                          dataSource={instructResponseList}
                                          hiddenPagination={true}
                                />
                            </div>
                        </div >
                        <div className="instruct_content" style={{marginLeft:80}}>
                            <div className={"commonTitle"}><label>{Strings.instructRule}</label></div>
                            <div className={"modal_item"}>
                                <span className="form_span">{Strings.rs10836 || Strings.taskname}</span>
                                <div className={"form_value"}>
                                    <Input value={name} placeholder={Strings.rs10846} maxLength={50}
                                           onChange={(e) => setName(e.target.value.trim())} disabled={!isAdd}/>
                                </div>
                            </div>
                            <div className={"modal_item"}>
                                <span className="form_span">
                                    <span style={{color: 'red'}}>*</span>{Strings.rs10155}
                                </span>
                                <div className={"form_value"}>
                                    <InstructTypeSelect value={routine} platform={props.platform} onChange={setRoutine} disabled={!isAdd}/>
                                </div>
                            </div>
                            {/*自定义指令*/}
                            {routine === "0"?<div  className={"modal_item mgb10"}>
                                <span className="form_span"/>
                                <div className={"form_value"}>
                                    <Input value={format}  type={'text'} autoComplete='new-password'
                                           onChange={(e)=>setFormat(e.target.value.trim())}
                                      placeholder={Strings.rs14362 || Strings.input6} maxLength={32} disabled={!isAdd}/>
                                </div>
                            </div>:null}
                            {routine === "0"?<div  className={"modal_item"}>
                                <span className="form_span"/>
                                <div className={"form_value tip"}><span>{Strings.rs14363}</span></div>
                            </div>:null}
                            <div className={"modal_item"}>
                                <span className="form_span">{Tools.isDeviceMgt(props.platform)?Strings.lsTime:Strings.rs10276}</span>
                                <div className={"form_value"}>
                                    <DatePicker value={time ? moment(time, formatTime) : null} disabled={!isAdd}
                                                format={formatTime} allowClear={true}
                                                placeholder={Strings.rs14337}
                                                className="calendar"
                                                onChange={setTime}
                                                showToday={false}
                                                showTime={true}
                                                disabledDate={Tools.handleDisabledBeforeDate}/>
                                </div>
                            </div>
                            <div className={"modal_item"}>
                                <span className="form_span">
                                    <span style={{color: 'red'}}>*</span>{Strings.sendtype}
                                </span>
                                <div className={"form_value"}>
                                    <Select className={"w240"} disabled={!isAdd} value={sendType} placeholder={Strings.sendtypeTips} onChange={(value)=>setSendType(value)}>
                                        {Tools.getOptionsFromGlobalEnums("enums.cmdSendType","select")}
                                    </Select>
                                </div>
                            </div>
                            {emailItems()}
                            <div className={"modal_item"}>
                                <span className="form_span">{sendType ==="1"?<span style={{color: 'red'}}>*</span>:""}{Strings.rs10277}</span>
                                <div className={"form_value"}>
                                    <DatePicker value={deadlineTime ? moment(deadlineTime, formatTime) : null} disabled={!isAdd}
                                                format={formatTime} allowClear={true}
                                                placeholder={Strings.rs14337}
                                                className="calendar"
                                                onChange={setDeadlineTime}
                                                showToday={false}
                                                showTime={true}
                                                disabledDate={Tools.handleDisabledBeforeDate}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
}

export default forwardRef(BatchInstructModalMicDetail)